
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'nameOneRowLen',
  components: {},
})
export default class nameOneRowLen extends Vue {
  @Prop() private wordText!: string;

  private wordLength = 0;

  getOneRowLength() {
    const str = this.wordText;
    const regex = /\n/; // 定义正则表达式 \n
    const matchResult = str.match(regex); // 使用 match() 函数进行匹配
    let length = str.length as any;
    if (matchResult) {
      length = matchResult.index;
    }
    this.wordLength = length;
    return '如果单位名称过长，请在折行处回车<br>名称共' + str.length + '个字，经计算，折行位置为<span class="length"> ' + length + ' </span>字之后';
  }

  getNumber() {
    return this.wordLength;
  }

  autoRow() {
    let text = this.wordText;
    const index = text.indexOf('公司');
    if (text.length > 10 && index != -1) {
      text = text.slice(0, index+2) + '\n' + text.slice(index+2);
      this.$message.success("智能换行成功");
    } else {
      this.$message.warning("未检测到需要换行的内容，如果内容过长，请手动在需要换行处点击回车");
    }
    this.wordText = text;
  }
}
